<script setup lang="ts">
  import { Button, ButtonSize } from '@travelata-libs/ui-kit';
  import { ref, onMounted, computed } from 'vue';
  import { AGENCY_FRANCHISING_URL } from '@/shared/config/agencySite';
  import { isRegionWithOffice } from '../api/isRegionWithOffice';

  interface OfficeTourButtonProps {
    isVisible?: boolean;
    size?: `${ButtonSize}`;
  }

  withDefaults(defineProps<OfficeTourButtonProps>(), {
    isVisible: true,
    size: ButtonSize.S,
  });

  interface OfficeTourButtonEmits {
    (e: 'buy'): void;
  }
  const emit = defineEmits<OfficeTourButtonEmits>();

  const regionWithOffice = ref(true);

  const onClick = () => {
    if (regionWithOffice.value) {
      emit('buy');
    } else {
      window.open(AGENCY_FRANCHISING_URL, '_blank', 'noopener');
    }
  };

  const text = computed(() => (regionWithOffice.value ? 'Купить тур в офисе' : 'Франшиза'));

  onMounted(async () => {
    regionWithOffice.value = await isRegionWithOffice();
  });
</script>

<template>
  <Button
    v-if="isVisible"
    type="button"
    class="office-tour-button"
    data-testid="office-tour-button"
    appearance="sub-primary"
    icon-left="briefcase"
    :size="size"
    @click="onClick"
  >
    {{ text }}
  </Button>
</template>

<style scoped lang="scss">
  .office-tour-button {
    background-color: transparent;
    border: 1px solid var(--color-neutral-0);
    color: var(--color-neutral-0);
  }
</style>
